import SlideshowSettingsContainer from './SlideshowSettingsContainer';

export default SlideshowSettingsContainer;
